<template lang="pug">
  .b2b-page-borrador-detail
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            h1 {{ $t('draft_detail.info_draft') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("draft_detail.copy_draft_tooltip")', placement='bottom')
                ods-button(
                  v-if='canCopyInvoiceDraft',
                  type='primary',
                  icon='ods-icon-copy',
                  size='small',
                  circle,
                  @click.native='handleCopyDraft')
                  | {{ $t('draft_detail.copy_draft') }}
              ods-tooltip(:content='$t("draft_detail.edit_draft_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-edit',
                  size='small',
                  circle,
                  @click.native='handleCreateInvoice')
                  | {{ $t('draft_detail.edit_draft') }}
              ods-tooltip(:content='$t("draft_detail.delete_draft_tooltip")', placement='bottom')
                ods-button(
                  type='primary',
                  icon='ods-icon-delete',
                  size='small',
                  circle,
                  @click.native='removeDraft')
                  | {{ $t('draft_detail.delete_draft') }}
      ods-form(
        ref='draftDetailEditForm',
        :model='draftDetailEditForm',
        label-width='14rem',
        label-position='top',
        size='small',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.invoice_number")',
              prop='invoiceNumber')
              ods-input(
                v-model='draftDetailEditForm.invoiceNumber',
                :disabled='true')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.seller")',
              prop='seller')
              ods-input(
                v-model='draftDetailEditForm.partySellerTradeName',
                :disabled='true')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.issue_date")',
              prop='issueDate')
              ods-input(
                v-model='issueDateFormatted',
                :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.total_executable_amount", {code: draftDetailEditForm.currency})',
              prop='totalExecutableAmount')
              ods-input(
                v-model='draftDetailEditForm.totalExecutableAmount',
                :disabled='true')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.buyer")',
              prop='buyer')
              ods-input(
                v-model='draftDetailEditForm.partyBuyerTradeName',
                :disabled='true')
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.creation_date_time")',
              prop='creationDateTime')
              ods-input(
                v-model='creationDateTimeFormatted',
                :disabled='true')
        ods-row.b2b-page-borrador-detail__form()
          ods-row()
            ods-form-item(
              :label='$t("draft_detail.draft_detail_edit_form.invoice_additional_information")',
              prop='invoiceAdditionalInformation')
          ods-row()
              ods-input(
                type='textarea',
                v-model='draftDetailEditForm.invoiceAdditionalInformation',
                :disabled='true')

    ods-module.collapse
      ods-accordion(@change='')
        ods-accordion-item(
          v-if='!(this.idRecadv && !canViewAttach) && this.draftDetailEditForm.formatDocumentName === "FACTURAE32" || this.draftDetailEditForm.formatDocumentName === "FACTURAE321"',
          name='1')
          template(slot='title')
            span {{ $t('draft_detail.attachment') }}
            span.info(v-show='!attachments.length') {{ $t('draft_detail.no_attachment') }}
          ods-button.button-collapse(
            icon='ods-icon-plus',
            size='small',
            circle,
            @click.native='isShowDialogAddAttachment = true')
            | {{ $t('draft_detail.add_attachment') }}

          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterAttachment',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("draft_detail.attachments_table.filename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("draft_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("draft_detail.attachments_table.size")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("draft_detail.attachments_table.compressedSize")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='creationDate',
              :label='$t("draft_detail.attachments_table.creationDate")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("draft_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button.first-button(
                  type='neutral',
                  @click='downloadAttachment')
                  ods-icon(name='download', size='16')
                ods-button(
                  type='neutral',
                  @click='removeAttachment')
                  ods-icon(name='close', size='16')

    //- Dialog Copiar Borrador
    ods-dialog(
      ref='dialogCopyDraft',
      :title='$t("draft_detail.dialog_copy_draft.title")',
      :visible.sync='isShowDialogCopyDraft',
      width='30%')
      ods-form(
        ref='formDialogCopyDraft',
        :model='formDialogCopyDraft',
        :rules='rulesFormCopy',
        label-position="top")
        ods-form-item(
          :label='$t("draft_detail.dialog_copy_draft.invoice_number")',
          prop='invoiceNumber')
          ods-input(
            v-model="formDialogCopyDraft.invoiceNumber")
        ods-form-item(
          :label='$t("draft_detail.dialog_copy_draft.issue_date")',
          prop='issueDate')
          ods-date-picker(
            v-model='formDialogCopyDraft.issueDate',
            type='datetime',
            :format='$t("date_format_calendar")',
            prefix-icon='prefix-icon-date-time-picker',
            align='right')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitCopyDraft("formDialogCopyDraft")')
          | {{ $t('draft_detail.dialog_copy_draft.button_copy') }}
          i.icon-upload-white
    //- Dialog Cargar Documento Adjunto
    ods-dialog(
      ref='dialogAddAttachment',
      :title='$t("draft_detail.dialog_add_attachment.title")',
      :visible.sync='isShowDialogAddAttachment',
      @close='handleCloseDialogAddAttachment',
      width='30%')
      ods-form(
        ref='formDialogAddAttachment',
        :model='formDialogAddAttachment',
        :rules='rulesFormDialogAddAttachment')
        ods-form-item(prop='fichero', ref='form-item-upload')
          ods-upload(
            ref='upload',
            action='#',
            :auto-upload='false',
            :on-change='onSuccessUpload',
            :on-remove='handleRemoveUpload',
            :file-list='fileList',
            :accept= 'extensionFormatsAccept.toString()')
            ods-button(
              icon='ods-icon-plus',
              size='small',
              circle)
              | {{ $t('draft_detail.dialog_add_attachment.form_dialog_add_attachment.select_file') }}
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddAttachment("formDialogAddAttachment")')
          | {{ $t('draft_detail.dialog_add_attachment.button_upload') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-borrador-detail',
  mixins: [Utils],
  data () {
    return {
      draftId: null,
      idRecadv: null,
      idOrder: null,
      deliveryId: null,
      draftDetailEditForm: {
        invoiceNumber: '',
        buyer: '',
        issueDate: '',
        totalExecutableAmount: '',
        seller: '',
        creationDateTime: '',
        invoiceAdditionalInformation: '',
        formatDocumentName: null
      },

      formDialogCopyDraft: {
        invoiceNumber: '',
        issueDate: ''
      },
      rulesFormCopy: {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 3, message: this.$t('msg_generics.min_three_letters') }
        ],
        issueDate: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ]
      },
      isShowDialogCopyDraft: false,

      // ARCHIVOS ADJUNTOS
      attachments: [],
      currentRowAttachment: {},
      isShowDialogAddAttachment: false,
      fileList: [],
      formDialogAddAttachment: {
        fichero: null
      },
      optionsAttachments: [],
      extensionFormatsAccept: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg'],
      extensionFormats: ['.pdf', '.xlsx', '.csv', '.xls', '.jpg', '.jpeg', '.xml', '.txt', '.doc', '.docx', '.zip', '.msg']
    }
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canCopyInvoiceDraft',
      'canViewAttach'
    ]),
    rulesFormDialogAddAttachment () {
      const checkExtension = (rule, value, callback) => {
        // Obtener la extension, y cuando la tengas, haces la validacion
        if (!this.validateExtension(this.formDialogAddAttachment.fichero.name)) {
          callback(new Error(this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension') + '.' + this.$t('invoices.dialog_add_invoice.attachments.error_attachment_extension_values') + this.extensionFormats.toString()))
        } else {
          this.fileList = []
          this.fileList.push(this.formDialogAddAttachment.fichero)
          callback()
        }
      }
      return {
        fichero: [
          { required: true, message: this.$t('msg_generics.no_file_selected'), trigger: 'click' },
          { validator: checkExtension }
        ]
      }
    },
    issueDateFormatted () { // eslint-disable-line
      if (this.draftDetailEditForm.issueDate) {
        const date = moment(this.draftDetailEditForm.issueDate)
        return date.format(this.$t('date_format'))
      }
    },

    creationDateTimeFormatted () { // eslint-disable-line
      if (this.draftDetailEditForm.creationDateTime) {
        const date = moment(this.draftDetailEditForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    }
  },

  methods: {
    ...mapActions([
      'getDraftDetail',
      'copyDraft',
      'deleteDraft',
      'getDraftAttachments',
      'downloadDraftAttachment',
      'deleteAttachment',
      'addDraftAttachment',
      'createInvoiceState'
    ]),

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    validateExtension (filename) {
      return this.extensionFormats.includes('.'.concat((filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)).toLowerCase()))
    },

    handleCellMouseEnterAttachment (row, column, cell, event) {
      this.currentRowAttachment = row
    },

    onSuccessUpload (file, fileList) {
      this.fileList = []
      this.fileList[0] = file
      this.formDialogAddAttachment.fichero = file
      this.$refs.formDialogAddAttachment.validateField('fichero')
    },

    handleRemoveUpload (file, fileList) {
      this.$refs['form-item-upload'].resetField('fichero')
      this.fileList = []
    },

    // Reseteo al cerrar dialogo de añadir adjunto
    handleCloseDialogAddAttachment () {
      this.$refs.formDialogAddAttachment.resetFields()
      this.fileList = []
    },
    // Duplicado del borrador
    handleCopyDraft () {
      this.formDialogCopyDraft.issueDate = this.draftDetailEditForm.issueDate
      this.isShowDialogCopyDraft = true
    },

    // Modificación de una factura
    async handleCreateInvoice () {
      const invoice = {
        draftId: this.draftId
      }
      // Comprobamos si es borrador de recepcion y si lo es, lo añadimos al objeto de sesion
      if (this.idRecadv) {
        invoice.idRecadv = this.idRecadv
      }
      if (this.idOrder) {
        invoice.idOrder = this.idOrder
      }
      if (this.deliveryId) {
        invoice.deliveryId = this.deliveryId
      }
      await this.createInvoiceState(invoice)
      router.push({ name: 'creacion-factura-borradores-modificacion', query: { type: 'DRAFT-MODIFY' } })
    },

    async downloadAttachment () {
      const load = this.$loading({
        lock: true,
        text: this.$t('draft_detail.load.download_attachment')
      })
      try {
        const dataQuery = {
          draftId: this.draftId,
          attachmentId: this.currentRowAttachment.id
        }

        const filename = await this.downloadDraftAttachment(dataQuery)

        this.$notify({
          title: this.$t('draft_detail.notify.download_attachment_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async removeAttachment () {
      this.$confirm(this.$t('draft_detail.confirm.title_delete_attachment'), {
        confirmButtonText: this.$t('draft_detail.confirm.confirm_button_delete_attachment'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('draft_detail.load.delete_attachment')
        })
        try {
          const dataQuery = {
            draftId: this.draftId,
            attachmentId: this.currentRowAttachment.id
          }

          await this.deleteAttachment(dataQuery)
          await this.getAttachmentsOnDatabase()

          this.$notify({
            title: this.$t('draft_detail.notify.delete_attachment_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          // No invocamos al método this.showNotificationError porque ya lo hace this.getAttachmentsOnDatabase
          console.log('removeAttachment CATCH: ', error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    async removeDraft () {
      this.$confirm(this.$t('draft_detail.confirm.title_delete_draft'), {
        confirmButtonText: this.$t('draft_detail.confirm.confirm_button_delete_draft'),
        showCancelButton: false,
        center: true,
        iconClass: 'ods-icon-warning'
      }).then(async () => {
        const load = this.$loading({
          lock: true,
          text: this.$t('draft_detail.load.delete_draft')
        })
        try {
          if(this.draftId && this.draftId!='_blank') { // eslint-disable-line
            const dataQuery = {
              draftId: this.draftId
            }
            await this.deleteDraft(dataQuery)
            this.$notify({
              title: this.$t('draft_detail.notify.delete_draft_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            router.push({ name: 'borradores-table' })
          }
        } catch (error) {
          console.log('removeDraft CATCH: ', error)
        } finally {
          load.close()
        }
      }).catch(() => {})
    },

    async onSubmitCopyDraft (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.draftId) {
          const load = this.$loading({
            lock: true,
            text: this.$t('draft_detail.load.copy_draft')
          })
          const dataQuery = {
            draftId: this.draftId,
            query: {
              invoiceNumber: this.formDialogCopyDraft.invoiceNumber,
              issueDate: this.formDialogCopyDraft.issueDate
            }
          }
          try {
            await this.copyDraft(dataQuery)
            this.isShowDialogCopyDraft = false
            this.$notify({
              title: this.$t('draft_detail.notify.copy_draft_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('ERROR submit!!')
          return false
        }
      })
    },

    async onSubmitAddAttachment (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid && this.draftId && this.draftId!='_blank') { // eslint-disable-line
          const data = {
            draftId: this.draftId,
            attachment: this.fileList[0]
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.upload_attachment')
          })
          try {
            await this.addDraftAttachment(data)

            await this.getAttachmentsOnDatabase()

            this.isShowDialogAddAttachment = false
            this.formDialogAddAttachment.fichero = null
            this.fileList = []

            this.$notify({
              title: this.$t('msg_generics.upload_attachment_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!!!')
          return false
        }
      })
    },

    // METODOS GENERALES PARA LLAMAR A SERVICIOS
    async getDraftOnDatabase () {
      try {
        if (this.draftId&& this.draftId!='_blank') { // eslint-disable-line
          const draft = await this.getDraftDetail(this.draftId)
          this.idRecadv = draft.idRecadv
          this.idOrder = draft.idOrder
          this.deliveryId = draft.idDNote
          this.draftDetailEditForm = draft
        }
      } catch (error) {
        console.log('getDraftOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getAttachmentsOnDatabase () {
      try {
        if (this.draftId && this.draftId!='_blank') { // eslint-disable-line
          const response = await this.getDraftAttachments(this.draftId)
          this.attachments = response
        }
      } catch (error) {
        console.log('getAttachmentsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = this.$i18n.messages.es.error.e400
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = this.$t('error.e404')
          break
        case 409:
          errorSms = this.$i18n.messages.es.error.e409
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    this.draftId = this.$route.params.draftId

    const load = this.$loading({
      lock: true,
      text: this.$t('draft_detail.load.init_draft_data')
    })
    try {
      if (this.draftId) {
      // Get Info
        await this.getDraftOnDatabase()

        // Formateamos los campos que sean números al locale
        this.draftDetailEditForm.totalExecutableAmount = this.$n(this.draftDetailEditForm.totalExecutableAmount, 'decimal')

        if (this.draftDetailEditForm.formatDocumentName === 'FACTURAE32' || this.draftDetailEditForm.formatDocumentName === 'FACTURAE321') {
          await this.getAttachmentsOnDatabase()
        }
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-borrador-detail {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
